import { useEffect } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import i18n from '../../i18n/config';

const cleanupDriverArtifacts = () => {
    const selectors = [
        '.driver-overlay',
        '.driver-popover',
        '.driver-stage',
        '.driver-highlighted-element',
        '.driver-active-element'
    ];

    selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
            if (el && el.parentNode) {
                el.parentNode.removeChild(el);
            }
        });
    });

    document.body.classList.remove('driver-active');
    document.documentElement.classList.remove('driver-active');

    if (document.body.style.pointerEvents === 'none') {
        document.body.style.pointerEvents = '';
    }
};

export const useTour = (shouldStart, steps = []) => {
        useEffect(() => {
            let driverObj = null;

            if (!shouldStart || !steps || steps.length === 0) {
                return;
            }

            const timer = setTimeout(() => {
                driverObj = driver({
                    showProgress: true,
                    showButtons: ['next', 'previous', 'close'],
                    steps,
                    nextBtnText: i18n.t('tours.next'),
                    prevBtnText: i18n.t('tours.previous'),
                    doneBtnText: i18n.t('tours.finish'),
                    progressText: i18n.t('tours.progress', {
                        current: '{{current}}',
                        total: '{{total}}',
                    }),

                // Enhanced settings
                animate: true,
                overlayOpacity: 0.75,
                smoothScroll: true,
                allowClose: true,
                overlayClickNext: false,

                // Popover styling
                popoverClass: 'medilink-tour-popover',

                // Callbacks
                onHighlightStarted: (element, step, options) => {
                    // Scroll element into view
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                },

                onDestroyStarted: () => {
                    if (typeof window !== 'undefined') {
                        const url = new URL(window.location);
                        url.searchParams.delete('guide');
                        url.searchParams.delete('tour');
                        window.history.replaceState({}, '', url);
                    }
                },
                onDestroyed: () => {},

                onPopoverRender: () => {}
            });

            try {
                driverObj.drive();
            } catch (error) {
                console.error('❌ Error starting tour:', error);
            }
        }, 1000);

        return () => {
            clearTimeout(timer);
            if (driverObj) {
                try {
                    driverObj.destroy();
                } catch (error) {
                    console.error('❌ Error destroying tour:', error);
                }
            }
            cleanupDriverArtifacts();
        };
    }, [shouldStart, steps]);
};